<template>
  <v-app id="inspire">
    <v-content>
      <div>
        <Header></Header>
        <div id="particles-js" @wheel="wheel" class="position-absolute"/>
        <div style="min-height:116px"/>
        <div class="scrollbar" ref="scroller" id="style-6">
          <RouterPage/>
          <Footer></Footer>
        </div>
      </div>
      <!-- BACK TO TOP BUTTON  -->
      <a @click="scroll" role="button" v-show="visible" class="shadow btn-primary rounded-circle back-to-top">
        <i class="fas fa-chevron-up"></i>
      </a>
    </v-content>
  </v-app>
</template>

<script>
import Header from './pages/HeaderComp.vue'
import Footer from './pages/FooterComp.vue'
import RouterPage from './routes/RouterPage.vue'

export default {
  name: 'NavisisWeb',
  components: {
    Header,
    RouterPage,
    Footer
  },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    scroll() {
      this.intervalId = setInterval(() => {
        if (this.$refs.scroller.scrollTop === 0) {
          clearInterval(this.intervalId)
        }
        this.$refs.scroller.scrollTop = this.$refs.scroller.scrollTop - 50;
      }, 20)
    },
    wheel(event) {
      let total = 0;
      let isNegative = event.deltaY < 0
      let positive = isNegative ? event.deltaY * -1 : event.deltaY
      const interval2Id = setInterval(() => {
        if (total >= positive) {
          clearInterval(interval2Id)
        }
        total += positive / 20
        this.$refs.scroller.scrollTop = this.$refs.scroller.scrollTop + event.deltaY / 20;
      }, 0.1);
    },
    scrollListener() {
      this.visible = this.$refs.scroller.scrollTop > 150
    },
  },
  mounted() {
    this.$refs.scroller.addEventListener('scroll', this.scrollListener)
    require('particles.js')
    window.particlesJS('particles-js', {
      "particles": {
        "number": {
          "value": 100,
          "density": {
            "enable": true,
            "value_area": 1000
          }
        },
        "color": {
          "value": ["#aa73ff", "#f8c210", "#83d238", "#33b1f8"]
        },
        "shape": {
          "type": "circle",
          "stroke": {
            "width": 0,
            "color": "#fff"
          },
          "polygon": {
            "nb_sides": 5,
            "color": "#111"
          },
        },
        "opacity": {
          "value": 0.3,
          "random": false,
          "anim": {
            "enable": false,
            "speed": 1,
            "opacity_min": 0.1,
            "sync": false
          }
        },
        "size": {
          "value": 8,
          "random": true,
          "anim": {
            "enable": false,
            "speed": 80,
            "size_min": 0.1,
            "sync": false
          }
        },
        "line_linked": {
          "enable": true,
          "distance": 120,
          "color": "#111",
          "opacity": 0.4,
          "width": 1
        }
      },
      "interactivity": {
        "detect_on": "window",
        "events": {
          "onhover": {
            "enable": true,
            "mode": "grab"
          },
          "onclick": {
            "enable": true
          },
          "resize": true
        },
        "modes": {
          "grab": {
            "distance": 140,
            "line_linked": {
              "opacity": 1
            }
          },
          "bubble": {
            "distance": 400,
            "size": 40,
            "duration": 2,
            "opacity": 8,
            "speed": 3
          },
          "repulse": {
            "distance": 200,
            "duration": 0.4
          },
          "push": {
            "particles_nb": 4
          },
          "remove": {
            "particles_nb": 2
          }
        }
      },
      "retina_detect": true
    });
  },
  beforeUnmount() {
    this.$refs.scroller.removeEventListener('scroll', this.scrollListener)
  }
}
</script>
<style>
body::-webkit-scrollbar {
  display: none;
}

.scrollbar {
  height: calc(100vh - 116px);
  width: 100vw;
  background: #F5F5F5;
  overflow-y: scroll;
}

#style-6::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #F5F5F5;
}

#style-6::-webkit-scrollbar {
  width: 7px;
  background-color: #F5F5F5;
}

#style-6::-webkit-scrollbar-thumb {
  background-color: #b070b0;
  background-image: -webkit-linear-gradient(45deg,
  rgba(255, 255, 255, .2) 25%,
  transparent 25%,
  transparent 50%,
  rgba(255, 255, 255, .2) 50%,
  rgba(255, 255, 255, .2) 75%,
  transparent 75%,
  transparent)
}
</style>